export default __webpack_public_path__ + "static/Westfalia_Logo_color-79aac39b3a162a16735145d32b3b20a3.png";